// extracted by mini-css-extract-plugin
export default {"container":"TabLayout_container__zoRq0","hasChanges":"TabLayout_hasChanges__LInu5","header":"TabLayout_header__mjUdS","title":"TabLayout_title__-s8vq"};